import * as React from 'react';
import * as styles from './styles.css';

import imgBg from '../assets/my-home-bg.png';

export const HeroBannerLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div data-testid="HeroBannerLayout" className={styles['container']}>
      <div className={styles['bg-image']}>
        <img src={imgBg} />
      </div>

      <div className={styles['wrapper']}>
        <div>{children}</div>
      </div>
    </div>
  );
};
